export enum DealEventCategory {
	CAPITAL = 'CAPITAL',
	PARTICIPANT = 'PARTICIPANT',
	ADMIN = 'ADMIN',
	MESSAGE = 'MESSAGE',
	ACCESS = 'ACCESS',
	AUTH = 'AUTH',
}

export enum DealEventSource {
	AUDIT = 'AUDIT',
	LEDGER = 'LEDGER',
	INVESTMENT_WORKFLOW = 'INVESTMENT_WORKFLOW',
	KYC = 'KYC',
	DOCUMENT_WORKFLOW = 'DOCUMENT_WORKFLOW',
	BANK_ACCOUNT_VERIFICATION = 'BANK_ACCOUNT_VERIFICATION',
	BANK_ACCOUNT_STATE = 'BANK_ACCOUNT_STATE',
	ACCESS = 'ACCESS',
	AUTH = 'AUTH',
	EMAIL_SENT = 'EMAIL_SENT',
}

export enum DealEventStatus {
	COMPLETED = 'COMPLETED',
	IN_PROGRESS = 'IN_PROGRESS',
	PENDING = 'PENDING',
	APPROVED = 'APPROVED',
	DRAFT = 'DRAFT',
	FAILED = 'FAILED',
	CANCELLED = 'CANCELLED',
	SUCCESS = 'SUCCESS',
	SENT = 'SENT',
	DELIVERED = 'DELIVERED',
	OPENED = 'OPENED',
	READ = 'READ',
	BOUNCED = 'BOUNCED',
	WARNING = 'WARNING',
	EXPIRED = 'EXPIRED',
	REJECTED = 'REJECTED',
}

export const EMAIL_EVENT_TYPE_PREFIX = 'EMAIL';

/**
 * Statuses each category's arms can actually report, in enum order. Offering anything else gives
 * a filter that always returns nothing; omitting one hides rows that exist. The backend owns the
 * per-source maps this is derived from, and its spec fails if the two drift.
 */
export const DEAL_EVENT_STATUSES_BY_CATEGORY: Record<DealEventCategory, DealEventStatus[]> = {
	[DealEventCategory.CAPITAL]: [DealEventStatus.COMPLETED],
	[DealEventCategory.ADMIN]: [DealEventStatus.COMPLETED],
	[DealEventCategory.PARTICIPANT]: [
		DealEventStatus.COMPLETED,
		DealEventStatus.IN_PROGRESS,
		DealEventStatus.PENDING,
		DealEventStatus.APPROVED,
		DealEventStatus.DRAFT,
		DealEventStatus.FAILED,
		DealEventStatus.CANCELLED,
		DealEventStatus.SUCCESS,
		DealEventStatus.WARNING,
		DealEventStatus.EXPIRED,
		DealEventStatus.REJECTED,
	],
	[DealEventCategory.ACCESS]: [
		DealEventStatus.COMPLETED,
		DealEventStatus.PENDING,
		DealEventStatus.FAILED,
		DealEventStatus.SUCCESS,
		DealEventStatus.WARNING,
	],
	[DealEventCategory.AUTH]: [
		DealEventStatus.PENDING,
		DealEventStatus.FAILED,
		DealEventStatus.SUCCESS,
		DealEventStatus.WARNING,
	],
	[DealEventCategory.MESSAGE]: [
		DealEventStatus.PENDING,
		DealEventStatus.FAILED,
		DealEventStatus.SENT,
		DealEventStatus.DELIVERED,
		DealEventStatus.OPENED,
		DealEventStatus.READ,
		DealEventStatus.BOUNCED,
		DealEventStatus.WARNING,
	],
};

/** Cap on the recipient filter's options; the DTO enforces it and the UI asks for it. */
export const MAX_RECIPIENT_OPTIONS = 100;

/** Cap on a keyword filter; the DTO rejects anything longer, so the input stops there too. */
export const MAX_SEARCH_LENGTH = 200;

export const DERIVED_AUDIT_FIELDS: Readonly<Record<string, readonly string[]>> = {
	HoldingEvent: ['description'],
};
